import { Flex, Group, Pill, Text } from '@mantine/core';

import { Content } from '@/core/components';

import { useCurrentUser } from '@feature/security';

import { GovEvaluation } from './../model/GovEvaluationTypes';
import { GovEvaluationAnnex1Button } from './GovEvaluationAnnex1Button';
import { GovEvaluationAnnex6Button } from './GovEvaluationAnnex6Button';

export interface EvaluationHeaderProps {
  evaluation: GovEvaluation;
}

export function GovEvaluationHeader({ evaluation }: EvaluationHeaderProps) {
  const { currentRole } = useCurrentUser();

  return (
    <Content type="full">
      <Flex
        justify="center"
        align="center"
        gap="4px"
      >
        <Text fw="500">{evaluation.title}</Text>
        <Pill bg={evaluation.open ? 'green' : 'red'}>{evaluation.open ? 'Deschisă' : 'Închisă'}</Pill>
      </Flex>
      {currentRole === 'UNIVERSITY_ADMIN' && evaluation.open && (
        <Group>
          <GovEvaluationAnnex6Button evaluationId={evaluation.id} />
          <GovEvaluationAnnex1Button evaluationId={evaluation.id} />
        </Group>
      )}
    </Content>
  );
}
